import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./msal";

export default function Protected({ children }: { children: React.ReactNode }) {
  const { instance, accounts, inProgress } = useMsal();

  useEffect(() => {
    instance.handleRedirectPromise().catch((err) => {
      console.error("MSAL redirect error:", err);
    });
  }, [instance]);

  useEffect(() => {
    if (accounts.length === 0 && inProgress === "none") {
      instance.loginRedirect(loginRequest).catch((err) => {
        console.error("MSAL loginRedirect error:", err);
      });
    }
  }, [accounts, inProgress, instance]);

  if (accounts.length === 0) {
    return (
      <div className="h-screen flex items-center justify-center">
        Autenticando...
      </div>
    );
  }

  return <>{children}</>;
}
